module.exports = __webpack_public_path__ + "img/voucherdesign.d2586352.svg";